/* global $ */
export default function scrollLock (noScroll) {
  if (noScroll) {
    if ($(document).height() > $(window).height()) {
      $('html').addClass('noScroll');
    }
  } else {
    $('html').removeClass('noScroll');
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scrolling/scrollLock.js